<template>
  <div>
    <Breadcrumbs 
      :children="[
        {
          text: 'Proveedores de pago',
        }
      ]"/>
    <div class="row" style="margin-left:10px;">
      <div class="col-sm-9">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <h4 style="margin-top:0;">Proveedores de pago</h4>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-outline-dark btn-sm" @click="openProviderModal">
                  <i class="fa fa-plus"></i>
                  Agregar Proveedor
                </button>
              </div>
            </div>
            <!-- Lista -->
            <div class="row">
              <div class="col-sm-12">
                <table class="table table-responsive" id="list">
                  <thead class="thead-light">
                    <tr>
                      <th>Nombre</th>
                      <th>Titular</th>
                      <th>No. de cuenta</th>
                      <th class="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pAccount in paymentProviders" :key="pAccount.id">
                      <td>{{ pAccount.name }}</td>
                      <td>{{ pAccount.client }}</td>
                      <td>
                        <b>{{ pAccount.account_number }}</b>
                      </td>
                      <td class="text-center">
                        <a @click.prevent="edit(pAccount)" href="#" title="Editar">
                          <i class="fa fa-edit fa-2x"></i>
                        </a>&nbsp;
                        <a
                          title="Eliminar"
                          @click="deleteProviderAccount(pAccount)"
                          href="#"
                          class="text-danger"
                        >
                          <i class="fa fa-trash fa-2x"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="loading" class="text-center">
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL Provider-->
    <div
      class="modal fade"
      id="provider-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm" role="document" style="max-width:400px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h4 v-if="editing" class="no-margin-top">Editar cuenta</h4>
            <h4 v-else class="no-margin-top">Agregar nueva cuenta</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Nombre</label>
              <input type="text" class="form-control" v-model="paymentProvider.name" />
            </div>
            <div class="form-group">
              <label>Titular de la cuenta</label>
              <input type="text" class="form-control" v-model="paymentProvider.client" />
            </div>
            <div class="form-group">
              <label>Número de cuenta</label>
              <input type="text" class="form-control" v-model="paymentProvider.account_number" />
            </div>
          </div>
          <div class="modal-footer">
            <div class="row w100">
              <div class="col-sm-4 text-left">
                <!-- Loader -->
                <div v-show="loading">
                  <div class="text-center" colspan="5">
                    <Loader />
                  </div>
                </div>

                <b v-show="!loading">
                  <a
                    style="margin-top:10px;"
                    @click="closeProviderModal()"
                    :disabled="loading"
                  >Cancelar</a>
                </b>
              </div>
              <div class="col-sm-8 text-right">
                <a
                  style="margin-top:0 !important;"
                  :disabled="paymentProvider.name == '' || loading"
                  @click="saveProvider"
                  class="btn main-blue-bg"
                >
                  <i class="fa fa-save"></i>&nbsp;
                  <span v-if="editing">Actualizar cuenta</span>
                  <span v-else>Agregar cuenta</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "../components/Breadcrumbs";
import Loader from '../components/Loader'
import {PaymentProvidersService} from '../../services/PaymentProvidersService'
export default {
  name: "Providers",
  components: { Breadcrumbs,Loader },
  data: function () {
    return {
      paymentProvider: {
        id: "",
        name: "",
        account_number: "",
        client: "",
      },
      paymentProviders: [],
      modalOptions: {
        keyboard: false,
        backdrop: false,
      },
      loading: false,
      editing: false,
      service: new PaymentProvidersService()
    };
  },
  methods: {
    edit(account) {
      this.editing = true;
      this.paymentProvider = Object.assign({}, account);
      $("#provider-modal").modal(this.modalOptions);
    },
    async saveProvider() {
      if (this.paymentProvider.name == "") {
        this.$helpers.toast("El nombre es obligatorio", "warning");
        return;
      }
      if (this.paymentProvider.account_number == "") {
        this.$helpers.toast("El numero de cuenta es obligatorio", "warning");
        return;
      }
      this.loading = true;
      try {
        if (this.paymentProvider.id == "") {

          const res = await this.service.addProvider(
            this.paymentProvider.name,
            this.paymentProvider.client, 
            this.paymentProvider.account_number
          );
          
          if(res.ok){
            this.$helpers.toast('Operacion exitosa!');      
          }else{
            this.$helpers.message('Error',res.message, 'error');
            return;
          }

        } else {
          const res = await this.service.editProvider(
            this.paymentProvider.id,
            this.paymentProvider.name,
            this.paymentProvider.client, 
            this.paymentProvider.account_number
          );
          
          if(res.ok){
            this.$helpers.toast('Operacion exitosa!');      
          }else{
            this.$helpers.message('Error',res.message, 'error');
            return;
          }

        }

        this.loading = false;
        this.$helpers.toast("Datos guardados");
        this.closeProviderModal();
        this.getProviders();
      } catch (e) {
        console.log("ERR >> ", e);
        this.loading = false;
      }
    },
    async getProviders() {
      this.loading = true;
      this.paymentProviders = [];
      const res = await this.service.getProviders();
      if(res.ok){
        this.paymentProviders = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
    openProviderModal() {
      $("#provider-modal").modal(this.modalOptions);
    },
    deleteProviderAccount: async function (x) {
      const ok = await this.$helpers.confirm('Estas seguro?');
      if(ok){
        try {
          const res = await this.service.deleteProvider(x.id);
          if(res.ok){
            this.$helpers.toast('Proveedor eliminado!');
            this.paymentProviders = this.paymentProviders.filter(a => a.id !== x.id);
          }else{
            this.$helpers.message('Error',res.message, 'error');
          }
        } catch (error) {
          console.log(error);
          this.$helpers.message('Error', 'Oops, algo salio mal', 'error');
        }
      }
    },
    openNewModal: function () {
      $("#category-modal").modal(this.modalOptions);
    },
    closeProviderModal() {
      this.paymentProvider = {
        id: "",
        name: "",
        account_number: "",
        client: "",
      };
      this.editing = false;
      $("#provider-modal").modal("hide");
    },
    initTable: function () {
      const parent = this;
      $("#list").DataTable({
        dom: "Bfrtip",
        paginate: true,
        scrollY: 340,
        order: [[0, "asc"]],
        language: this.$helpers.getDatatableLanguageDefinitions(),
      });
    },
  },
  created: async function () {
    this.getProviders();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fs1 {
  font-size: small;
}
* {
  font-weight: 500;
}
.w100 {
  width: 100%;
}
.preview-badge {
  margin-left: 3px;
  float: left;
  border-radius: 11px;
  color: #fff;
  padding: 4px 8px;
  margin-top: 3px;
  margin-bottom: 3px;
  background-color: #001;
  display: table;
  font-size: 0.7em;
}
.no-margin-top {
  margin-top: 1px;
}
.flex {
  display: flex;
}
</style>
